import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t, i18n } = useTranslation();
  const hasContent4 = i18n.exists("footer.about.content4");

  return (
    <>
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold mb-6 text-[#bc943e]">{t("footer.about.title")}</h2>
              <p className="text-gray-600 mb-4">
                {t("footer.about.content1")}
              </p>
              <p className="text-gray-600 mb-4">
                {t("footer.about.content2")}
              </p>
              <p className="text-gray-600 mb-4">
                {t("footer.about.content3")}
              </p>
              <p className="text-gray-600">
                {hasContent4 ? t("footer.about.content4") : null}
              </p>
            </div>
            <div className="relative">
              <img 
                src="./Image_20241224230049.png"
                alt="Migration Services" 
                className="rounded-lg object-cover hover:object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="contact-section" className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8 text-[#bc943e]">{t("footer.contact.title")}</h2>
          <div className="space-y-4">
            <div className="flex items-center space-x-3 text-[#4b5563]">
              <Phone className="w-5 h-5 text-[#C5A572]" />
              <span>{t("footer.contact.phone")}</span>
            </div>
            <div className="flex items-center space-x-3 text-[#4b5563]">
              <Mail className="w-5 h-5 text-[#C5A572]" />
              <span>{t("footer.contact.email")}</span>
            </div>
            <div className="flex items-center space-x-3 text-[#4b5563]">
              <MapPin className="w-5 h-5 text-[#C5A572]" />
              <span>{t("footer.contact.address")}</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};